<template>
    <div class="edit_program_body" v-if="handle_data.question">
        <div class="box question-templeat">

            <div class="desc-title">The following agreements and disclaimers will appear at the bottom of your application.</div>

            <div class="edit-item" v-for="(v, k) in handle_data.question.filter(e=>{return e.client_view && !e.is_only_client})" :key="k">
                <div class="line">
                    <div class="name">{{ v.name }}<div class="red">*</div></div>
                    <div class="handle_req">
                        <Switch v-if="!v.is_edit && v.label==='i_confirm_that_i_am_18_years_or_older'" :checked="v.is_switch" @click.native="v.is_switch = v.is_switch ? false : true" />
                        <el-button v-if="v.is_edit" class="small-btn" size="small" @click="saveEdit(v.index)">
                            <svg-icon name="yes-2"/>
                            Save
                        </el-button>
                    </div>
                </div>

                <div class="value-box" v-if="!(v.label === 'i_confirm_that_i_am_18_years_or_older' && !v.is_switch) && !v.is_edit && v.client_view">
                    <div class="value">{{ v.client_view.desc }}</div>
                </div>

                <Field v-if="v.is_edit" :type="'textarea'" :k="v.index" :placeholder="v.client_view.plac" @update="updateValue" :had_value="v.client_view.name" :max_value="100" />

                <div class="url-box" v-if="v.url_title">
                    <div class="url-box-content">
                        <div class="title" v-if="v.client_view.edit_desc" v-html="v.client_view.edit_desc"></div>
                        <Field :type="'text'" :k="v.index" :placeholder="'https://www.website.com'" @update="update" :had_value="v.url"/>
                        <div class="err-msg-box" v-if="v.error">
                            <p class="err-msg" v-html="v.error"></p>
                            <i><svg-icon name="alert" class="icon-left" /></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- save -->
            <div class="save-btn-box-spec">
                <el-button type="primary" size="large" class="save-btn" :disabled="disabled_save" @click="save()">Save</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import Switch from '@/components/ui/Switch.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Field from '@/components/ui/Field.vue';
import { ElButton } from 'element-plus';

const props = defineProps({
    data: { type: Object, default: () => ({}) },
    barnd_name: { type: String, default: '' },
});

const emit = defineEmits(['close', 'save', 'del']);

const store = useStore();

const handle_data = ref({});
const default_option = ref(['Yes', 'No', 'Unsure']);
const is_show_alert_modal = ref(false);

const had_opt = computed(() => handle_data.value.id === 0 || handle_data.value.id === 1);
const disabled_save = computed(() =>
    handle_data.value.question?.some(e => e.error) ||
    handle_data.value.question?.some(e => e.url !== undefined && e.url === '')
);

const isValidUrl = (string) => {
    const url_pattern = /^(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?$/;
    return url_pattern.test(string);
};

const update = (obj) => {
    handle_data.value.question[obj.key].error = '';
    handle_data.value.question[obj.key].url = obj.val;
    const url = handle_data.value.question[obj.key].url;
    if (url && !isValidUrl(url)) {
        handle_data.value.question[obj.key].error = `The url format is incorrect.`;
    }
};

const updateValue = (obj) => {
    handle_data.value.question[obj.key].client_view.temp_name = obj.val;
};

const saveEdit = (k) => {
    const val = handle_data.value.question[k].client_view.temp_name;
    handle_data.value.question[k].client_view.name = val;
    handle_data.value.question[k].client_view.val = val;
    handle_data.value.question[k].is_edit = false;
};

const save = (is_return = false) => {
    handle_data.value.question.forEach(e => {
        const label1 = 'i_have_read_and_acknowledge_privacy_policy';
        const label2 = 'i_have_read_and_acknowledge_terms_and_conditions';

        if (e.for_label === label1) {
            const item = handle_data.value.question.find(q => q.label === label1);
            if (item) e.val = item.url;
        }
        if (e.for_label === label2) {
            const item = handle_data.value.question.find(q => q.label === label2);
            if (item) e.val = item.url;
        }
    });

    if (is_return) {
        return [handle_data.value];
    } else {
        emit('save', { data: [handle_data.value], type: 'agreements_disclaimers' });
    }
};

const close = () => emit('close');

const start = () => {
    handle_data.value = props.data[0];
    const merchant_name = store.state.user_data?.merchant_account?.merchant_display_name;

    handle_data.value.question.forEach(question => {
        if (question.client_view && question.client_view.desc) question.client_view.desc = question.client_view.desc.replaceAll('{brand}', merchant_name);
        if (question.client_view && question.client_view.name) question.client_view.name = question.client_view.name.replaceAll('{brand}', merchant_name);
        if (question.client_view && question.client_view.plac) question.client_view.plac = question.client_view.plac.replaceAll('{brand}', merchant_name);

        switch (question.label) {
            case 'i_have_read_and_acknowledge_privacy_policy':
                question.client_view.edit_desc = `Please provide link to your Privacy Policy.`;
                break;
            case 'i_have_read_and_acknowledge_terms_and_conditions':
                question.client_view.edit_desc = `Please provide link to your Terms & Conditions.`;
                break;
        }
    });

    handle_data.value.question.forEach(e => {
        const label1 = 'i_have_read_and_acknowledge_privacy_policy';
        const label2 = 'i_have_read_and_acknowledge_terms_and_conditions';

        if (e.label === label1) {
            const item = handle_data.value.question.find(q => q.for_label === label1);
            if (item) e.url = item.val;
        }
        if (e.label === label2) {
            const item = handle_data.value.question.find(q => q.for_label === label2);
            if (item) e.url = item.val;
        }
    });
};

defineExpose({ save });

onMounted(() => {
    start();
});
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.edit_program_body {

    .desc-title{
        font-size: 12px;
        color:var(--black-75);
    }

    .line{
        @include flexCenter();

        .small-btn{
            @include flexCenter();
            height: unset;
            color:var(--green);
            border: solid 1px var(--border);

            .svg-icon{
                fill:var(--green);
                margin-right: 4px;
            }
        }
    }

    .name {
        font: var(--font-med-16);
        @include flexCenter();
        flex: 1;
    }

    .value-box{
        @include flexCenter();
        flex: 1;
        margin-top: 4px;
        .value{
            font-size: 14px;
            color:var(--black-75);
            flex: 1;
        }

        .svg-icon{
            width: 16px;
            height: 16px;
            cursor: pointer;
            fill:var(--black-50);
        }
    }

    .url-box{
        .url-box-content{
            border-left: solid 2px #CBD4E1;
            padding-left: 17px;
            .title{
                font:var(--font-med-14);
            }
        }

        .err-msg-box{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color:var(--alert);

            i{
                width: 14px;
                height: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 5px;
            }

            svg{
                width: 10.5px;
                height: 10.5px;
                fill:var(--alert);
            }
        }
    }

    .ui-input{
        margin: 4px 0;
        flex:1;
    }

    .save-btn-box-spec{
        padding: 16px 0 0;

        .ui-button,.el-button{
            width: 100%;
            text-align: center;
        }
    }

}
</style>
